import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MobileNavItem } from '../mobile-shell/mobile-nav.config';
import { NotificationStore } from '../../core/notifications/notification.store';

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss'
})
export class BottomNavComponent {
  @Input({ required: true }) items: MobileNavItem[] = [];
  protected readonly notificationStore: NotificationStore;

  constructor(
    private readonly router: Router,
    notificationStore: NotificationStore
  ) {
    this.notificationStore = notificationStore;
  }

  ngOnInit(): void {
    this.notificationStore.refreshUnreadCount().catch(() => undefined);
  }

  isActive(item: MobileNavItem): boolean {
    const cleanUrl = this.router.url.split('?')[0].split('#')[0];
    return item.matchPrefixes.some((prefix) => cleanUrl === prefix || cleanUrl.startsWith(`${prefix}/`));
  }

  protected badgeForItem(item: MobileNavItem): number {
    if (item.id !== 'notifications') {
      return 0;
    }
    return this.notificationStore.unreadCount();
  }
}
